<template>
  <div v-if="api_data.Farmer" class="card rounded-0 card-custom gutter-b">
    <div class="card-header border-0 pt-5">
      <div class="card-title">
        <div class="card-label">
          <router-link
              v-if="api_data.Farmer.id"
              class="btn btn-info btn-xs"
              style="margin: 2px"
              :to="{ name: 'farmer-show', params: { id: api_data.Farmer.id }}">
            {{ $t("Back") }}
          </router-link>
          <router-link class="btn btn-default btn-xs"
                       :to="{ name: 'farmer'}">
            {{ $t("List") }}
          </router-link>
          <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <form v-on:submit.prevent="storeData" method="post">
            <div>
              <div class="form-group">
                <label>{{ $t("Organization") }}</label>
                <input type="text" v-model="api_data.Farmer.account_holder_organization"
                       class="form-control"/>
              </div>
              <div class="form-group">
                <label>{{ $t("Number") }}</label>
                <input type="text" v-model="api_data.Farmer.account_holder_number"
                       class="form-control"/>
              </div>
              <div class="form-group">
                <label>{{ $t("Account Holder\'s Name") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder"
                       class="form-control"/>
              </div>
              <div class="form-group">
                <label>{{ $t("Surname") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder_surname"
                       class="form-control"/>
              </div>
              <div class="form-group">
                <label>{{ $t("Gender") }}</label>
                <div class="radio-inline">
                  <label class="radio radio-lg">
                    <input type="radio" value="male" name="basic_account_holder_gender"
                           v-model="api_data.Farmer.basic_account_holder_gender">
                    <span></span>{{ $t("Male") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="female" name="basic_account_holder_gender"
                           v-model="api_data.Farmer.basic_account_holder_gender">
                    <span></span>{{ $t("Female") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="other" name="basic_account_holder_gender"
                           v-model="api_data.Farmer.basic_account_holder_gender">
                    <span></span>{{ $t("Other") }}</label>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("Marriage") }}</label>
                <div class="radio-inline">
                  <label class="radio radio-lg">
                    <input type="radio" value="no"
                           name="basic_account_holder_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_marriage_status">
                    <span></span>{{ $t("No") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="yes"
                           name="basic_account_holder_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_marriage_status">
                    <span></span>{{ $t("Yes") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="widow"
                           name="basic_account_holder_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_marriage_status">
                    <span></span>{{ $t("Widow") }}</label>
                </div>
              </div>
              <div
                  v-if="api_data.Farmer.basic_account_holder_marriage_status == 'yes' && (api_data.Farmer.basic_account_holder_gender == 'male' || api_data.Farmer.basic_account_holder_gender == 'other')"
                  class="form-group">
                <label>{{ $t("Wife") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder_wife"
                       class="form-control"/>
              </div>
              <div
                  v-if="api_data.Farmer.basic_account_holder_marriage_status == 'yes' && (api_data.Farmer.basic_account_holder_gender == 'female' || api_data.Farmer.basic_account_holder_gender == 'other')"
                  class="form-group">
                <label>{{ $t("Husband") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder_husband"
                       class="form-control"/>
              </div>
              <div class="form-group">
                <label>{{ $t("Brother") }} {{ $t("Name") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder_brother"
                       class="form-control"/>
              </div>
              <div v-if="api_data.Farmer.basic_account_holder_brother" class="form-group">
                <label>{{ api_data.Farmer.basic_account_holder_brother || '' }} {{ $t("Marriage") }} {{
                    $t("Status")
                  }}</label>
                <div class="radio-inline">
                  <label class="radio radio-lg">
                    <input type="radio" value="no"
                           name="basic_account_holder_brother_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_brother_marriage_status">
                    <span></span>{{ $t("No") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="yes"
                           name="basic_account_holder_brother_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_brother_marriage_status">
                    <span></span>{{ $t("Yes") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="widow"
                           name="basic_account_holder_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_brother_marriage_status">
                    <span></span>{{ $t("Widow") }}</label>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("Sister") }} {{ $t("Name") }}</label>
                <input type="text" v-model="api_data.Farmer.basic_account_holder_sister"
                       class="form-control"/>
              </div>
              <div v-if="api_data.Farmer.basic_account_holder_sister" class="form-group">
                <label>{{ api_data.Farmer.basic_account_holder_sister || '' }} {{ $t("Marriage") }} {{
                    $t("Status")
                  }}</label>
                <div class="radio-inline">
                  <label class="radio radio-lg">
                    <input type="radio" value="no"
                           name="basic_account_holder_sister_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_sister_marriage_status">
                    <span></span>{{ $t("No") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="yes"
                           name="basic_account_holder_sister_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_sister_marriage_status">
                    <span></span>{{ $t("Yes") }}</label>
                  <label class="radio radio-lg">
                    <input type="radio" value="widow"
                           name="basic_account_holder_marriage_status"
                           v-model="api_data.Farmer.basic_account_holder_sister_marriage_status">
                    <span></span>{{ $t("Widow") }}</label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-6">
          <div>
            <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded">
              <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
                <i class="icon-xl fab fa-whatsapp"></i>
              </div>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_whatsapp"
                     class="form-control"/>
            </div>
            <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded">
              <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
                <i class="icon-xl fas fa-mobile-alt"></i>
              </div>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_mobile"
                     class="form-control"/>
            </div>
            <div class="form-group">
              <label>{{ $t("Address") }}</label>
              <textarea type="text"
                        v-model="api_data.Farmer.basic_account_holder_address"
                        class="form-control"></textarea>
            </div>
            <div class="form-group">
              <label>{{ $t("District") }}</label>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_district"
                     class="form-control"/>
            </div>
            <div class="form-group">
              <label>{{ $t("Village") }}</label>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_village"
                     class="form-control"/>
            </div>
            <div class="form-group">
              <label>{{ $t("Panchayat") }}</label>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_panchayat"
                     class="form-control"/>
            </div>
            <div class="form-group">
              <label>{{ $t("Taluko") }}</label>
              <input type="text" v-model="api_data.Farmer.basic_account_holder_taluko"
                     class="form-control"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labelText from '../labelText'
import titleHead from '../titleHead'

export default {
  name: 'operation-basic-information',
  component: [
    labelText,
    titleHead
  ],
  props: {
    api_data: Object,
    data: Object,
  }
}
</script>
